import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { axiosRestInstance } from "../../../../common/axios";
import { AxiosResponse } from "axios";
import { partnerLicenceSliceAction } from "../../../slices/partner-program/licence-management";
import {
  AddPartnerLicenceDetailsType,
  getPartnerLicenceListSagaAction,
  partnerLicenceSagaActionTypes,
  updatePartnerLicenceListPayloadType,
  deletePartnerLicenceListPayloadType,
} from "./saga-actions";
import { PartnerLicenceListType } from "../../../slices/partner-program/licence-management/Types";

type getPartnerLicenceDeatilsListAPIResponseType = {
    success: boolean;
    message: string;
    data: PartnerLicenceListType;
};
const getAllPartnersLicenceListAPI = async (programId?: number) => {
    let response = axiosRestInstance
        .get<AxiosResponse<getPartnerLicenceDeatilsListAPIResponseType>>(
            "/partner-program/licenses/getData",  {params: programId ? { program_id: programId } : undefined,}
        )
        .then((res) => 
            res.data);
    return response;
};


type addPartnerLicenceListAPIResponseType = {
  success: boolean;
  message: string;
  data: any;
};
const insertPartnerLicenceListAPI = async (partnerDetails: AddPartnerLicenceDetailsType) => {
  let response = axiosRestInstance
    .post<AxiosResponse<addPartnerLicenceListAPIResponseType>>(
      "/partner-program/licenses/insert",
      partnerDetails
    )
    .then((res) => res.data);
  return response;
};


type updatePartnersLicenceistAPIResponseType = {
  success: boolean;
  message: string;
  data: any;
};
const updatePartnerLicenceListAPI = async (partnerLicence: updatePartnerLicenceListPayloadType) => {
  let response = axiosRestInstance
    .put<AxiosResponse<updatePartnersLicenceistAPIResponseType>>(
        "/partner-program/licenses/update/" + partnerLicence.ID,
        partnerLicence
    )
    .then((res: { data: any; }) => res.data);
  return response;
};

type deletePartnerLicenceAPIResponseType = {
  success: boolean;
  message: string;   
  data: any;
};
const deletePartnerTierAPI = async (partnerLicenceID: number) => {
  let response = axiosRestInstance
    .delete<AxiosResponse<deletePartnerLicenceAPIResponseType>>("/partner-program/licenses/" + partnerLicenceID)
    .then((res) => res.data);
  return response;
};

// ----------------------- API Above

function* getAllPartnersLicenceListSaga(action: {
    type: string;
    payload: {
        ID: number;
    };
}) {
    try {
        yield put(partnerLicenceSliceAction.setPartnerLicenceListLoading(true));
        let response: getPartnerLicenceDeatilsListAPIResponseType = yield call(
            getAllPartnersLicenceListAPI,
            action.payload.ID,
        );
        const list = response.data ? response.data.reverse() : [];
        yield put(partnerLicenceSliceAction.setPartnerLicenceList(list));
        yield put(partnerLicenceSliceAction.setPartnerLicenceListLoading(false));
        yield put(partnerLicenceSliceAction.setFetchedPartnerLicenceID(action.payload.ID));
    } catch (e) {
        yield put(partnerLicenceSliceAction.setPartnerLicenceList([]));
        yield put(partnerLicenceSliceAction.setPartnerLicenceListLoading(false));
        console.log(e);
    }
}


function* addPartnerLicenceListSaga(action: {
  type: string;
  payload: AddPartnerLicenceDetailsType;
}) {
  try {
    yield put(partnerLicenceSliceAction.setAddPartnerLicenceLoading(true));
    let response: addPartnerLicenceListAPIResponseType = yield call(
      insertPartnerLicenceListAPI,
      action.payload
    );
    yield put(partnerLicenceSliceAction.setAddPartnerLicenceLoading(false));
    yield put(partnerLicenceSliceAction.setAddPartnerLicenceMessage(""));
    yield put(partnerLicenceSliceAction.setAddPartnerLicenceStatus(true));
    yield put(getPartnerLicenceListSagaAction(0));
  } catch (e: any) {
    yield put(
      partnerLicenceSliceAction.setAddPartnerLicenceMessage(
        e.response?.data?.message || "Something went wrong!"
      )
    );
    yield put(partnerLicenceSliceAction.setAddPartnerLicenceLoading(false));
    yield put(partnerLicenceSliceAction.setAddPartnerLicenceStatus(false));
    console.log(e);
  }
}

function* updatePartnerLicenceListSaga(action: {
  type: string;
  payload: { partnerLicence: updatePartnerLicenceListPayloadType };
}) {
  try {
    yield put(partnerLicenceSliceAction.setUpdatePartnerLicenceLoading(true));
    yield put(partnerLicenceSliceAction.setUpdatePartnerLicenceMessage(""));

    const resp: { success: boolean; message: string; data: any } = yield call(
      updatePartnerLicenceListAPI,
      action.payload.partnerLicence
    );

    if (resp?.success) {
      yield put(partnerLicenceSliceAction.setUpdatePartnerLicenceStatus(true));
      yield put(partnerLicenceSliceAction.setUpdatePartnerLicenceMessage(resp.message ?? "Updated"));
      yield put(
        partnerLicenceSliceAction.setPartnerLicenceListUpdate(action.payload.partnerLicence)
      );
    } else {
      yield put(partnerLicenceSliceAction.setUpdatePartnerLicenceStatus(false));
      yield put(
        partnerLicenceSliceAction.setUpdatePartnerLicenceMessage(
          resp?.message ?? "Update failed"
        )
      );
    }
    yield put(getPartnerLicenceListSagaAction(0));
  } catch (e: any) {
    yield put(partnerLicenceSliceAction.setUpdatePartnerLicenceStatus(false));
    yield put(partnerLicenceSliceAction.setUpdatePartnerLicenceMessage(e?.message ?? "Unexpected error"));
  } finally {
    yield put(partnerLicenceSliceAction.setUpdatePartnerLicenceLoading(false));
  }
}

function* deletePartnerLicenceListSaga(action: {
  type: string;
  payload: deletePartnerLicenceListPayloadType;
}) {
  try {
    yield put(partnerLicenceSliceAction.setDeletePartnerLicenceLoading(true));
    let response: deletePartnerLicenceAPIResponseType = yield call(
      deletePartnerTierAPI,
      action.payload.ID
    );
    yield put(partnerLicenceSliceAction.setDeletePartnerLicenceStatus(true));
    yield put(getPartnerLicenceListSagaAction(0));
    action.payload.setOpen(false);
  } catch (e: any) {
    yield put(partnerLicenceSliceAction.setDeletePartnerLicenceStatus(false));
    yield put(
      partnerLicenceSliceAction.setDeletePartnerLicenceMessage(
        e?.response?.data?.message || "Something went wrong"
      )
    );
    console.log(e);
  } finally {
    yield put(partnerLicenceSliceAction.setDeletePartnerLicenceLoading(false));
  }
}

function* partnerLicenceListSaga() {
    yield takeLatest(partnerLicenceSagaActionTypes.callPartnerLicenceListSaga, getAllPartnersLicenceListSaga);
    yield takeLatest(partnerLicenceSagaActionTypes.callAddPartnerLicenceSaga, addPartnerLicenceListSaga);
     yield takeLatest(partnerLicenceSagaActionTypes.callUpdatePartnerLicenceSaga, updatePartnerLicenceListSaga);
     yield takeLatest(partnerLicenceSagaActionTypes.callDeletePartnerLicenceSaga, deletePartnerLicenceListSaga);

}
export default partnerLicenceListSaga;